import { render, staticRenderFns } from "./FalhaRetornos.vue?vue&type=template&id=0a61d02e"
import script from "./FalhaRetornos.vue?vue&type=script&lang=js"
export * from "./FalhaRetornos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/thales/Recuperi/recuperi/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a61d02e')) {
      api.createRecord('0a61d02e', component.options)
    } else {
      api.reload('0a61d02e', component.options)
    }
    module.hot.accept("./FalhaRetornos.vue?vue&type=template&id=0a61d02e", function () {
      api.rerender('0a61d02e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/FalhaRetornos.vue"
export default component.exports